import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from "../../login/shared/auth.service";

const MINUTES_UNITL_AUTO_LOGOUT = 5 // in mins
const CHECK_INTERVAL = 50000 // in ms
const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root'
})

export class AutologoutService {

  Val: any;
  constructor(private router: Router, private authService: AuthService) {

    this.Check();
    this.InitListener();
    this.InitInterval();
    localStorage.setItem(STORE_KEY, Date.now().toString());
  }

  public GetLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  public SetLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  InitInterval() {

    setInterval(() => {
      this.Check();
    }, CHECK_INTERVAL);
  }

  InitListener() {
    document.body.addEventListener('click', () => this.Reset());
    document.body.addEventListener('mouseover', () => this.Reset());
    document.body.addEventListener('mouseout', () => this.Reset());
    document.body.addEventListener('keydown', () => this.Reset());
    document.body.addEventListener('keyup', () => this.Reset());
    document.body.addEventListener('keypress', () => this.Reset());
    window.addEventListener("storage", () => this.StorageEvt());
  }

  Reset() {

    // console.log('date got by using events', Date.now());
    this.SetLastAction(Date.now());
    // console.log('store key', localStorage.getItem(STORE_KEY));
  }

  StorageEvt() {
    // console.log("storage");
    this.Val = localStorage.getItem(STORE_KEY);
  }

  Check() {

    const now = Date.now();
    const timeleft = this.GetLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    // console.log('difference', diff)
    const isTimeout = diff < 0;

    if (isTimeout) {
      // localStorage.clear();
      // this.router.navigate(['./login']);
      this.logout();
    }
  }

  // session logout 
  logout() {

    this.authService.logout();
    localStorage.setItem("IsLoggedIn", "false");
    localStorage.removeItem("EmployeeData");
    localStorage.clear();
    this.router.navigate(['/login']);
  }

}
